import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TfCopyPayloadOptions } from '@app/modules/tf-copy-to-clipboard/types/copyPayloadOptions.type';
import { TfCopyToClipboardService } from '@app/modules/tf-copy-to-clipboard/services/tf-copy-to-clipboard.service';

const defaultOptions: TfCopyPayloadOptions = {
    helperDescription: '',
    showHelper: false,
    showConfirmation: true,
    successMessage: 'Copied to clipboard',
    showSuccess: true
};

@Component({
    selector: 'tf-copy-to-clipboard',
    templateUrl: './tf-copy-to-clipboard.component.html',
    styleUrls: ['./tf-copy-to-clipboard.component.scss']
})
export class TfCopyToClipboardComponent implements OnInit {

    @Input() content: string = '';

    @Input() options: TfCopyPayloadOptions = {};

    @Output() onCopy: EventEmitter<boolean> = new EventEmitter<boolean>();

    showConfirmation: boolean = false;

    @HostListener('document:mousedown', ['$event'])
    clickout(event) {
        if (event?.target?.id != 'copyBtn') {
            this.closeOpt()
        }
    }

    constructor(
        private readonly copyToClipboardService: TfCopyToClipboardService
    ) {
    }

    ngOnInit(): void {
        this.options = {...defaultOptions, ...this.options};
    }

    copyToClipboard() {

        const saved = this.copyToClipboardService.copyToClipboard(this.content);

        if (saved) {
            this.showConfirmation = true;
            setTimeout(() => {
                this.showConfirmation = false;
                this.onCopy.emit(true);
            }, 3000);
        } else {
            this.onCopy.emit(false);
        }
    }

    displayHelper(): boolean {
        return this.options.showHelper && this.options.helperDescription != '';
    }

    closeOpt(): void {
        this.onCopy.emit(false);
    }

    getExtraClasses(): string {
        return this.options?.resetConfirmationPosition ? 'reset-position' : '';
    }
}
